import { render, staticRenderFns } from "./PracticeNonConformities.vue?vue&type=template&id=0a37d0da&"
import script from "./PracticeNonConformities.vue?vue&type=script&lang=js&"
export * from "./PracticeNonConformities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports